import toastr from 'react-hot-toast'
import { useMutation, useQueryClient } from 'react-query'
import { SPARK_RESOURCE_TYPES } from 'constants/common'
import { useBatchAddOperations } from 'hooks/batchOperations'

type mutationVariables = {
  categoryID: string
  mainCategory: boolean
}

export function useAddBatchSparkCategories(sparkID: string | undefined) {
  const queryClient = useQueryClient()
  const { mutateAsync: addSparkCategories } = useBatchAddOperations()

  const addSparkCategory = (sparkCategories: mutationVariables[]) => {
    if (!sparkID) {
      Promise.reject('SparkID can not be null')
    }
    const categoryArray = sparkCategories.map((category) => ({
      type: SPARK_RESOURCE_TYPES.SPARK_CATEGORIES,
      attributes: { ...category, sparkID },
    }))

    return addSparkCategories(categoryArray)
  }

  return useMutation('addSparkCategory', addSparkCategory, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(['sparks', sparkID])
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Post Spark category: ${error.message}`)
      }
    },
  })
}
